import React from 'react'
import Containerchat from './Containerchat'
import Sidebar from './Sidebar'
import "./ChatPage.css"
function ChatPage({ currentUser, signOut }) {
  return (
    <div className="chatpage">
      <div className="chatpage-container">
        
        <Sidebar currentUser={currentUser} signOut={signOut} />
       
        <Containerchat currentUser={currentUser} />
      </div>
    </div>
  );
}

export default ChatPage